import { render, staticRenderFns } from "./crosssell.vue?vue&type=template&id=18fe199f&"
import script from "./crosssell.vue?vue&type=script&lang=js&"
export * from "./crosssell.vue?vue&type=script&lang=js&"
import style0 from "./crosssell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CrosssellItem: require('/opt/build/repo/storefront/components/legacy/global/crosssell-item.vue').default,Slider: require('/opt/build/repo/storefront/components/legacy/global/slider.vue').default})
